import { useLocation, useSearchParams } from 'react-router-dom';
import { PageDto } from '@asset-metrix/portal-gateway-client-js';

import { DETAILS_PAGE_URL_DISCRIMINATOR_PARAM } from '../../utils/constants';
import { getDetailsFromSearchParams } from '../../utils/getDetailsFromSearchParams';

export function useOriginHrefForDetailsPage(pageData?: PageDto): string {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const { detailsDiscriminator, detailsValue, detailsLabel } =
    getDetailsFromSearchParams(searchParams, { pageData });

  let backLinkUrlSearch = '';
  if (
    detailsDiscriminator != null &&
    detailsValue != null &&
    detailsLabel != null
  ) {
    const backLinkUrlSearchParams = new URLSearchParams({
      [detailsDiscriminator]: detailsValue,
      [DETAILS_PAGE_URL_DISCRIMINATOR_PARAM]: detailsDiscriminator,
      label: detailsLabel,
    });
    backLinkUrlSearch = '?' + backLinkUrlSearchParams.toString();
  }

  return location.pathname + backLinkUrlSearch;
}
